"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

var utils_1 = require("../../utils/utils");

exports.container = function (isFeedback, color, backgroundColor) {
  return typestyle_1.style({
    marginBottom: isFeedback ? "25px" : "0px"
  }, {
    borderTop: "2px solid ".concat(color)
  }, {
    padding: "16px"
  }, {
    backgroundColor: backgroundColor
  });
};

exports.titleStyle = function (color) {
  return typestyle_1.style({
    fontSize: "14px"
  }, {
    fontWeight: 600
  }, {
    marginBottom: "8px"
  }, {
    fontStretch: "normal"
  }, {
    fontStyle: "normal"
  }, {
    lineHeight: "normal"
  }, {
    letterSpacing: "normal"
  }, {
    color: color
  });
};

exports.optionListContainer = typestyle_1.style({
  listStyle: "none"
}, {
  flexWrap: "wrap"
}, {
  display: "flex"
}, {
  justifyContent: "space-evenly"
}, {
  paddingLeft: 0
});

exports.optionList = function (color, backgroundColor) {
  return typestyle_1.style({
    minWidth: "45%"
  }, {
    margin: "5px"
  }, {
    padding: "5px 20px"
  }, {
    borderRadius: "15px"
  }, {
    border: "1px solid #e8e9f1"
  }, {
    cursor: "pointer"
  }, {
    flexGrow: 1
  }, {
    display: "flex"
  }, {
    alignItems: "center"
  }, {
    justifyContent: "center"
  }, {
    fontSize: "15px"
  }, {
    textAlign: "center"
  }, {
    fontFamily: "inherit"
  }, {
    color: color
  }, {
    wordWrap: "break-word"
  }, {
    $nest: {
      "&:hover": {
        backgroundColor: backgroundColor === "#ffffff" ? utils_1.LightenDarkenColor(backgroundColor, -20) : utils_1.LightenDarkenColor(backgroundColor, 50)
      }
    }
  });
};

exports.option = function (fontFamily) {
  return typestyle_1.style({
    wordBreak: "break-word"
  }, {
    fontFamily: "inherit"
  });
};